import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { MetricCard } from '../components/growth/MetricCard';
import { KPIGauge } from '../components/growth/KPIGauge';
import { PerformanceTrendChart } from '../components/growth/PerformanceTrendChart';
import { LeadSourceBreakup } from '../components/growth/LeadSourceBreakup';
import { LeadTypeOverview } from '../components/growth/LeadTypeOverview';
import { LeadQueryOverview } from '../components/growth/LeadQueryOverview';
import { FloatingCart } from '../components/billing/FloatingCart';
export function GrowthConsole() {
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2156">
      <Sidebar data-id="element-2157" />
      <main className="flex-1" data-id="element-2158">
        <Header data-id="element-2159" />
        <div className="px-6 py-6" data-id="element-2160">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-2161">
            Growth Console
          </h1>

          {/* Top Metrics Cards */}
          <div className="grid grid-cols-5 gap-4 mb-6" data-id="element-2162">
            <MetricCard label="Spend" value="₹11.25M" data-id="element-2163" />
            <MetricCard label="CPC" value="₹21.64" data-id="element-2164" />
            <MetricCard label="CTR" value="0.96%" data-id="element-2165" />
            <MetricCard label="Leads" value="101.85K" data-id="element-2166" />
            <MetricCard label="CPL" value="₹110.43" data-id="element-2167" />
          </div>

          {/* KPI Gauges */}
          <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm mb-6" data-id="element-2168">
            <h2 className="text-base font-semibold text-gray-900 mb-6" data-id="element-2169">KPI</h2>
            <div className="grid grid-cols-4 gap-8" data-id="element-2170">
              <KPIGauge label="Call Answered Ratio" percentage={64} value="35362/55253" color="#2563eb" data-id="element-2171" />
              <KPIGauge label="Call Leads with Status" percentage={80} value="59460/74325" color="#2563eb" data-id="element-2172" />
              <KPIGauge label="Call Leads Sync" percentage={37} value="15584/42118" color="#2563eb" data-id="element-2173" />
              <KPIGauge label="Enquiry to Booking Ratio" percentage={7} value="2850/40708" color="#ef4444" data-id="element-2174" />
            </div>
          </div>

          {/* Performance Trend Chart */}
          <div className="mb-6" data-id="element-2175">
            <PerformanceTrendChart data-id="element-2176" />
          </div>

          {/* Bottom Row: Lead Source, Lead Type, Lead Query */}
          <div className="grid grid-cols-3 gap-6 mb-6" data-id="element-2177">
            <div className="col-span-2" data-id="element-2178">
              <LeadSourceBreakup data-id="element-2179" />
            </div>
            <LeadTypeOverview data-id="element-2180" />
          </div>

          {/* Lead Query Overview - Full Width */}
          <LeadQueryOverview data-id="element-2181" />
        </div>
      </main>

      {/* Floating Cart */}
      <FloatingCart data-id="element-2182" />
    </div>;
}